/**
 * Block 12 Entry Screen 2.12.1 — 8 карточек типов мебели.
 *
 * Источник правды `anketaType` — `CALCULATOR_ANKETA_TYPES` vocabulary
 * (`@pomoshnik/shared`, Phase A1). Здесь — UI metadata: label, description.
 *
 * MUST: label / desc — на русском, не локализуем (KZ/RU/UZ — все RU first per CLAUDE.md).
 * Локализация — Phase 9+ через LinguiJS.
 *
 * Порядок: строго как в прототипе `screen-2.12.1-start.html` items array
 * (kitchen → cabinet → bath-tabletop → bath-shelf-above → bath-cabinet → tv-zone
 * → balcony → other).
 *
 * Hotfix-2A Phase A5 Step 12 (Aibek decision 2026-05-16): убраны иконки
 * полностью. Text-only cards. Closes Audit Round 2 Bug 13. Снимает риск
 * рассинхронизации lucide icons vs прототип; упрощает design.
 */

import { type CalculatorAnketaType } from '@pomoshnik/shared';

export interface AnketaTypeCard {
  anketaType: CalculatorAnketaType;
  label: string;
  description: string;
}

export const ANKETA_TYPE_CARDS: readonly AnketaTypeCard[] = [
  {
    anketaType: 'kitchen',
    label: 'Кухня',
    description: 'Прямая или угловая, расчёт по фасадам и столешнице',
  },
  {
    anketaType: 'cabinet',
    label: 'Шкаф / Гардероб',
    description: 'С наполнением: штанга, пантограф, обувница и т.д.',
  },
  {
    anketaType: 'bath-tabletop',
    label: 'Санузел: тумба со столешницей',
    description: 'Со стиральной машиной или без',
  },
  {
    anketaType: 'bath-shelf-above',
    label: 'Санузел: шкаф над антресолью',
    description: 'Минимальная конструкция, без столешницы',
  },
  {
    anketaType: 'bath-cabinet',
    label: 'Санузел: шкаф',
    description: 'Со стиральной и сушильной машиной',
  },
  {
    anketaType: 'tv-zone',
    label: 'ТВ-зона в гостиную',
    description: 'Тумба + шкаф + витрина в алюминиевом профиле',
  },
  {
    anketaType: 'balcony',
    label: 'Шкаф на балкон',
    description: 'Расчёт без фасадов МДФ',
  },
  {
    anketaType: 'other',
    label: 'Другая мебель',
    description: 'Свободный режим: добавляйте свои позиции',
  },
] as const;
